import { render, staticRenderFns } from "./GFMProfile.vue?vue&type=template&id=5c209e00&scoped=true&"
import script from "./GFMProfile.vue?vue&type=script&lang=js&"
export * from "./GFMProfile.vue?vue&type=script&lang=js&"
import style0 from "./GFMProfile.vue?vue&type=style&index=0&id=5c209e00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c209e00",
  null
  
)

export default component.exports